const a = 6, e = "d162487b93f5f358c5824358b26da389Tz0xMDA4OTcsRT0xNzYzMTA0MTM2MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y", s = {
  None: {
    isoName: "None",
    isoNumericCode: 0,
    symbol: "None"
  },
  MultiCurrency: {
    isoName: "Multicurrency",
    isoNumericCode: 5,
    symbol: "Multicurrency"
  }
}, i = {
  monetarySeparation: "\\B(?=(\\d{3})+(?!\\d))",
  lowerCase: "[a-z]",
  upperCase: "[A-Z]",
  number: "\\d",
  isPositiveNumber: "^\\d+$",
  positiveOrNegativeInteger: "^-?\\d+$",
  positiveOrNegativeFloat: "^-?\\d*.?\\d+$",
  onlyNumberOrLetter: "^[A-Za-z\\d]+$",
  validUrl: "^((?:https?:)?(?:/{2})?)?((?:[\\w\\d-_]{1,64})\\.(?:[\\w\\d-_.]{2,64}))(:\\d{2,6})?((?:/|\\?|#|&){1}(?:[\\w\\d\\S]+)?)?$",
  allLetters: "[^A-Za-z]",
  hasLetters: "[A-Za-z]",
  uuid: "^(?:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$",
  floatingPointNumber: "^(((([0-9]{1,3}[,.]{1})([0-9]{3}[,.]{1})*[0-9]{3})|[0-9]{1,9})([,.]{1}[0-9]+)?)$",
  email: '^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
  phoneNumber: "^[\\d|-]+$",
  emailWithPlus: /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  swift: "^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$",
  withoutNumbers: "^[^\\d]+$",
  bankName: "^[A-Za-z][A-Za-z\\d -.,]*$",
  userName: "^[^@\\d]+$",
  /**
   * signatoryUserName
   * ^(?=.([0-9]+[a-z])) - обязательно должен присутствовать текст и если есть буквы то допустими цифры
   * [^@|*~`!@#$%^&()_={}[\\]:;,.<>+\\/?-\\d] - список символов которые недопустимы без букв
   */
  signatoryUserName: "^(?=.([0-9]+[a-z]))|[^@|*~`!@#$%^&()_={}[\\]:;,.<>+\\/?-\\d]",
  hasApostropheOrSharp: "[#|']",
  hasSymbols: /[-?:().,'+#=!"%&*<>;{@]/,
  isEmailValid: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
  guid: "^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$"
};
export {
  s as CURRENCIES_OPS,
  e as LICENSE_KEY,
  a as OTP_CODE_LENGTH,
  i as REGEXP
};
//# sourceMappingURL=constants11.mjs.map
